import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import InstallationDetail from './pages/InstallationDetail'
import Welcome from './pages/Welcome'
import { LoginPage } from './../pages/Login'
import { LogoutPage } from './../pages/Logout'
import Callback from './../pages/Callback'
import { RequireAuth } from './../utils/RequireAuth'
import { GlobalStateProvider, useGlobalState } from "./../utils/globalStateProvider"
import { GlobalStateInterfaceApp, GlobalStateProviderApp } from "./utils/globalStateProviderApp"
import { useAuth0 } from '@auth0/auth0-react'
import { Spin } from 'antd';
import CompareAssets from './pages/CompareAssets'
import { I18n } from '@aws-amplify/core'
import { USER_CHOICE_LANGUAGE} from './../utils/consts';
import { fetchOrganizationName } from './../utils/helpersFetch'
import { useEffect, useState } from 'react'
import Header from './../components/Header';
import Footer from './../components/Footer';
import moment from 'moment'
import { strings as stringGlobal } from './../utils/globalLocalization'
import React from 'react'
import { RedirectPage } from '../pages/Redirect'
import { IsDsMember, checkUrlOrganizationAgainSessionOrganizationAndLogoutIfRequired, getAuth0Token, getLangByLocalStorage } from '../utils/helpers'
import { Status404 } from '../pages/Status_404'
import { DeviceFilterEnum } from '../interfaces/DeviceFilters'
import posthog from 'posthog-js'

I18n.putVocabularies(stringGlobal);
let lang = getLangByLocalStorage()
I18n.setLanguage(lang)

export default function AppDevices() {

  const { isLoading, error,user, logout, loginWithRedirect,getAccessTokenSilently } = useAuth0();
  const [speakingOrgName, setSpeakingOrgName] = useState<string>('');
  const { state, setState } = useGlobalState()
  const { search } = useLocation();

  const loginWithoutOrg = () => {
    loginWithRedirect({
      appState: {
        returnTo: '/',
      },
    });
  }

  useEffect(() => {
    if(user){
      checkUrlOrganizationAgainSessionOrganizationAndLogoutIfRequired(user,logout)
      posthog.identify(user.sub)
      posthog.setPersonProperties({visitedDevices:"yes"})

      const setPosthogDSMemberProperty = async () => {
        if(await IsDsMember(await getAuth0Token(getAccessTokenSilently))){
          posthog.setPersonProperties({isDsMember:"yes"})
        }  
        else{
          posthog.setPersonProperties({isDsMember:"no"})
        }
      }
  
      setPosthogDSMemberProperty()
    }
  }, [user]);

  useEffect(() => {
    if(state.organizationName && state.organizationIdentifier){
      console.log(state.organizationName)
      posthog.group(state.organizationName, state.organizationIdentifier, {
        name: state.organizationName,        
    });
  }
}, [state.organizationName,state.organizationIdentifier]);
  
    useEffect(() => {
      if(state.language){
        I18n.setLanguage(state.language)
        moment.locale(state.language);
        document.documentElement.lang = state.language
      }
      else{
        const query = new URLSearchParams(search);
        let langDefaulvalue = query.get("lang")
        let lang:string='de'
        if(langDefaulvalue){
          lang = langDefaulvalue
          localStorage.setItem(USER_CHOICE_LANGUAGE, lang);
        }
        I18n.setLanguage(lang)
        moment.locale(lang);
        document.documentElement.lang = lang        
      }
}, [ state.language]);      
   
    if (error) {
      let errorMessage = error.message

    if (errorMessage.includes('is not part of the') && errorMessage.includes('organization')) {
      // case: user google-apps|robert@digitalspine.io is not part of the org_BdGtxj3VINHioKjk organization
      let messageParts = errorMessage.split(' ')
      let organizationName = messageParts[7]

      const getOrgName = async (organizationName: string) => {
        let organization = await fetchOrganizationName(organizationName)
        if (organization) {
          setSpeakingOrgName(organization.displayName)
        }
      }
      getOrgName(organizationName)
      errorMessage = I18n.get('auth0ErrorMessageNotPartOfOrg').replace('###orgName###', speakingOrgName)
    }
    else {
      errorMessage = I18n.get(error.message)
    }

    return <>
      <Header isLoggedout={true} />
      <div className="flex w-full  items-center justify-center flex-col pt-20 pb-20 text-center pl-4 pr-4 min-h-[50vh]">
        <h2>{I18n.get('errorOccurred')}</h2>
        <h3 className="pt-5">{errorMessage}</h3>
        <h3>{I18n.get('messageGoTo')}<span onClick={() => loginWithoutOrg()} className=" font-bold cursor-pointer">Login</span>.</h3>
      </div>
      <Footer />
    </>
  }

  if (isLoading) {
    return <div className="flex h-screen"><div className="m-auto"><Spin size="large" /></div></div>;
  }

  return (
    <>
      <GlobalStateProvider>
        <GlobalStateProviderApp>
          <Routes>
            <Route path="/" element={<Navigate to={'/welcome'} />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="/redirect" element={<RedirectPage />} />
            <Route path="/404" element={<Status404 entity='installation' />} />
            <Route element={<RequireAuth />}>
              <Route path='/callback' element={<Callback />} />
              <Route path='/welcome' element={<Welcome />} />
              <Route path='/:organizationName/compare-assets' element={<CompareAssets />} />
              <Route path='/:organizationName/welcome' element={<Welcome />} />
              <Route path="/:organizationName/installations/:installationId" element={<InstallationDetail />} />
            </Route>
            <Route path="*" element={<Navigate to={'/'} />} />
          </Routes>
        </GlobalStateProviderApp>
      </GlobalStateProvider>
    </>
  );
}

